import {
  READING_LEVEL_DEFAULT,
  READING_LEVELS,
  type ReadingLevel,
} from "@rosc/contracts";

export { READING_LEVEL_DEFAULT, READING_LEVELS, type ReadingLevel };

// The patient summary reading level last chosen, remembered in this browser
// per account (the account has no server-side preference for it). Storage can
// be unavailable (private mode): then every summary starts at the default.
const KEY = "rosc:summaryReadingLevel";
type Account = string | null | undefined;
const keyFor = (account: Account): string =>
  account ? `${KEY}:${account}` : KEY;

export const isReadingLevel = (value: unknown): value is ReadingLevel =>
  READING_LEVELS.some((level) => level === value);

export const readReadingLevel = (account: Account): ReadingLevel => {
  try {
    const saved = window.localStorage.getItem(keyFor(account));
    return isReadingLevel(saved) ? saved : READING_LEVEL_DEFAULT;
  } catch {
    return READING_LEVEL_DEFAULT;
  }
};

export const rememberReadingLevel = (
  account: Account,
  level: ReadingLevel,
): void => {
  try {
    window.localStorage.setItem(keyFor(account), level);
  } catch {
    // A convenience only.
  }
};
